import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
const changeValue_ = (state, data) => {
	state[`${data.name}`] = data.value;
};

export default {
	resetState_,
	changeValue_,
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	}
};
